module.exports = __webpack_public_path__ + "static/media/corn-bag.7d8f95f7.svg";